<!--
 * @Description: 计划管理日志
 * @Author: Tina
 * @Date: 2022-12-16 10:32:21
 * @LastEditors: Tina
 * @LastEditTime: 2023-02-07 14:21:14
 -->

<template>
  <div class="sale-plan" @keyup.enter="enterSearch">
    <el-form ref="form" :model="form" inline class="table-search-bar" label-width="90px">
      <el-form-item label="价目表名称" prop="lockRuleName">
        <el-input v-model="form.lockRuleName" placeholder="请输入价目表名称"></el-input>
      </el-form-item>
      <el-form-item label="商品名称" prop="productName">
        <el-input v-model="form.productName" placeholder="请输入商品名称"></el-input>
      </el-form-item>
      <el-form-item label="日期" prop="time">
        <el-date-picker
          v-model="form.time"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="list"
      style="width: 100%"
      tooltip-effect="light">
      <el-table-column
        prop="createTime"
        label="日期"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="lockRuleName"
        label="价目表名称"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="customerRatingName"
        label="模板名称"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="itemName"
        label="商品名称"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="takeAreaName"
        label="提货区域"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="第一时段">
        <el-table-column
          prop="firstStageFirstCount"
          label="第一阶段"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="firstStageSecondCount"
          label="第二阶段"
          show-overflow-tooltip>
        </el-table-column>
      </el-table-column>
      <el-table-column label="第二时段">
        <el-table-column
          prop="secondStageFirstCount"
          label="第一阶段"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="secondStageSecondCount"
          label="第二阶段"
          show-overflow-tooltip>
        </el-table-column>
      </el-table-column>
      <el-table-column label="第三时段">
        <el-table-column
          prop="thirdStageFirstCount"
          label="第一阶段"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="thirdStageSecondCount"
          label="第二阶段"
          show-overflow-tooltip>
        </el-table-column>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNo"
      background
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange">
    </el-pagination>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'salePlanManageHistory',
  data () {
    return {
      form: {
        lockRuleName: '',
        productName: '',
        time: ''
      }
    }
  },
  computed: {
    ...mapGetters({ list: 'getSalePlanManageExecutingList', listState: 'getSalePlanManageExecutingListState' })
  },
  methods: {
    ...mapActions(['getSalePlanManageExecutingList']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    // 搜索
    handleSearch () {
      const params = { ...this.form, pageNo: 1 }
      this.getSalePlanManageExecutingList(params)
    },
    // 查询表单，表格重置
    handleReset () {
      this.$refs.form.resetFields()
      this.handleSearch()
    },
    // 分页条数变更
    handleSizeChange (val) {
      this.getSalePlanManageExecutingList({ pageSize: val, pageNo: 1 })
    },
    // 分页跳转
    handleCurrentChange (val) {
      this.getSalePlanManageExecutingList({ pageNo: val })
    },
    formatStatus (row) {
      const status = this.$lodash.find(this.statusArr, { value: row.status }) || {}
      return status.label
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>

<style scoped>

</style>
